module.exports = __webpack_public_path__ + "static/img/kcli-pt.7d4aff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kcli-pt.jpg
// module id = jfOz
// module chunks = 0